<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col
        :span="4"
        class="cs-main-left-container"
      >
        <navigator></navigator>
      </el-col>
      <el-col
        :span="20"
        class="backgroud-gray cs-fullHeight cs-main-right-container"
      >
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">校园热点</span>
                <el-row class="grid-content">
                  <el-col>
                    <pagination v-loading="loading" :data="listData" @loadData="onListDataLoad" :option="paginationOption" @search="onSearch" @add="onAdd" @edit="onEdit" @delete="onDelete">                        
                    </pagination>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :center="true"
      :close-on-click-modal="false"
      width="600px"
      :visible.sync="dialogEditorVisible"
      top="5vh"
    >
      <schoolHotEditor
        :dataIn="editData"
        @closeDialog="onEditClose"
        @saveSuccess="onEditSaveSuccess"
      ></schoolHotEditor>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.grid-content {
    /deep/ .el-table .cell {
      white-space: pre-line;
    }
}
</style>

<script>
import navigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import schoolHotEditor from "../../components/schoolHotEditor";

import {
  getSchoolHotPageList,
  deleteSchoolHot
} from "../../service/schoolHot.service";

export default {
  data() {
    return {
      loading: false,
      listData: {},
      paginationOption: {},
      editData: {},
      editIndex: -1,
      dialogEditorVisible: false,
      searchKeyword: "",
      pageSize: 20
    };
  },
  components: {
    navigator,
    pagination,
    schoolHotEditor
  },
  created(){
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: true,
      editButtonText: "编辑",
      hasAddButton: true,
      addButtonText: "添加",
      hasDeleteButton: true,
      hasSearch: false,
      hasEnableButton: false
    };
    this.search();
  },
  mounted() {
    
  },
  methods: {
    onAdd(){
      this.editData = {
        Id: 0,
        Title: "",
        Description:"",
        LinkUrl:"",
        PictureUrl:"",
        Enable:false
      };
      this.dialogEditorVisible = true;
    },
    onEdit(index, row) {     
      this.editIndex = index;
      this.editData = row;
      this.dialogEditorVisible = true;
    },
    onDelete(index, row) {
      if (!!row) {

        this.$confirm("您确定要删除该热点吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            if (!row.Id) {
              this.deleteRow(index);
            } else {
              deleteSchoolHot(row.Id).then(result => {
                if (result.success) {
                  this.deleteRow(index);
                } else {
                  this.$message.error(result.message);
                }
              });
            }
          })
          .catch(() => {});
      }
    },
    deleteRow(index) {
      if (index >= 0 && index < this.listData.Results.length) {
        this.$delete(this.listData.Results, index);
      }
    },
    onSearch(keyword) {
      this.searchKeyword = keyword;
      this.search();
    },
    onListDataLoad(pageData) {
      this.search(pageData.pageNumber);
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: this.searchKeyword,
        startDate: "",
        endDate: "",
      };
      return pageData;
    },
    search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      this.getListData(pageData);
    },
    getListData(pageData) {
      this.loading = true;
      getSchoolHotPageList(pageData).then(result => {
        if (result && result.success) {
          this.listData = result.data;
        }
        this.loading = false;
      });
    },
    onEditClose() {
      this.dialogEditorVisible = false;
    },
    onEditSaveSuccess() {
      this.search();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/admin/schoolHotList.vue